const cave = {
    readyFn: function () {
        let self = this;
        self.caveInit();
    },

    caveInit: function () {
        $("#cave .wrapper-repeteur .cell-repeteur").on("click", function () {
            console.log("appuie");
            $("#cave .wrapper-repeteur .cell-repeteur").removeClass("actif");
            $(this).addClass("actif");
            $(".section_deux").removeClass("actif");
            if ($(this).hasClass("first")) { // Correction ici
                $(".section_deux.first").addClass("actif");
            }
            if ($(this).hasClass("second")) { // Correction ici
                $(".section_deux.second").addClass("actif");
            }
        });
    },

};

export { cave };